import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {startWith, map, debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { NormalizeStringService } from 'src/app/service/normalizeStrings/normalize-string.service';
import { Observable, Subject } from 'rxjs';


@Component({
  selector: 'app-optional-input-autocomplete',
  templateUrl: './optional-input-autocomplete.component.html',
  styleUrls: ['./optional-input-autocomplete.component.scss'],
})
export class OptionalInputAutocompleteComponent  implements OnInit, AfterViewInit {
  @Input() placeholder: string = "";
  @Input() options: any[] = [];
  @Input() displayProperty: string = '';
  @Input() initialInputValue: string = "";
  @Input() addAlertIcon: boolean = false;
  @Input() addChevronDownIcon: boolean = false;
  @Input() onlyAcceptNumber: boolean = false;
  @Output() optionSelected: EventEmitter<any> = new EventEmitter<any>();

  control = new FormControl(this.initialInputValue);
  filteredOptions: Observable<any[]>;
  private valueChangeSubject = new Subject<string>();
  @ViewChild('autoInput') autoInput: ElementRef;
  @ViewChild('autoInput', { read: MatAutocompleteTrigger }) trigger: MatAutocompleteTrigger;
  private isInitialized = false;
  constructor(
    private normalizeStringService: NormalizeStringService,
  ) { }

  ngOnInit() {
    this.valueChangeSubject.subscribe(value => {
      if (this.isInitialized && (value || value === '') && typeof value === 'string') {
        this.optionSelected.emit(value);
      }
    });
    this.control.setValue(this.initialInputValue);
  }

  ngOnChanges() {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      // distinctUntilChanged(),
      map(value => {
        if (typeof value === 'string') {
          this.valueChangeSubject.next(value);
        };
        return this._filter(value || '');
      })
    );

    setTimeout(() => {
      this.isInitialized = true;
    }, 20);
  }

  ngAfterViewInit() {}

  private _filter(value: string): any[] {
    let filterValue = "";
    if (typeof value === 'string') {
      filterValue = this.normalizeStringService.normalizeValue(value);
    }
    else if (this.displayProperty && value[this.displayProperty]) {
      filterValue = this.normalizeStringService.normalizeValue(value[this.displayProperty]);
    }

    return this.options.filter(option => {
      if (typeof option === 'string') {
        return this.normalizeStringService.normalizeValue(option).includes(filterValue);
      }
      else if (this.displayProperty && option[this.displayProperty]) {
        return this.normalizeStringService.normalizeValue(option[this.displayProperty]).includes(filterValue);
      }
      return false;
    });
  }

  getDisplayValue(option: any): string {
    if (typeof option === 'string') {
      return option;
    }
    return this.displayProperty ? option[this.displayProperty] : option;
  }

  onOptionSelected(event: any) {
    const selectedValue = event.option.value;
    this.optionSelected.emit(selectedValue);
  }

  onInputBlur() {
    const currentValue = this.control.value;
    if (currentValue && typeof currentValue === 'string') {
      this.optionSelected.emit(currentValue);
    }
  }

  onClearInput() {
    this.control.reset();
    this.optionSelected.emit(null);
  }

  openAutocomplete() {
    this.autoInput.nativeElement.focus();
    this.trigger.openPanel();
  }

  filterKeyNumber(e) {
    const key = e.charCode;
    if (key < 48 || key > 57) {
      return e.preventDefault();
    }
  }

  displayFn(option: any): string {
    if (!option) return '';
    if (typeof option === 'string') {
      return option;
    }
    return this.displayProperty ? option[this.displayProperty] : option;
  }
}
